import { Box, Button, DialogContent, IconButton, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftDoubleIcon, ArrowRightIcon, PlusIcon } from '~/assets/icons';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { handleGetJob } from '~/thunks/job/jobThunk';
import { adminRouteAbsolute } from '~/utils/constants/route';
import { handleApiError } from '~/utils/helper';

const AreaScopeListMoisturePoints = () => {
  //#region Hooks
  const { t } = useTranslation('admin/job');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { id, index: area } = useParams<{ id: string; index: string }>();
  const checkAddScope = true;
  //#endregion Hooks

  //#region Selector
  const { groupedMoisturePoints } = useAppSelector((state) => state.job);
  //#endregion Selector

  //#region Load Job Data
  useEffect(() => {
    if (id) {
      (async () => {
        try {
          await dispatch(handleGetJob(id.toString())).unwrap();
        } catch (e) {
          handleApiError(e);
        }
      })();
    }
  }, [id, dispatch]);
  //#endregion Load Job Data

  //#region Derived Data
  const group = groupedMoisturePoints.find((g) => g.key === area);
  const items = group?.items ?? [];
  const areaName = group?.area ?? area;
  //#endregion Derived Data

  //#region Handlers
  const handleSetOpen = () => {
    if (id) {
      navigate(`${adminRouteAbsolute.jobDetail.replace(':id', id)}#areaScope`);
    }
  };

  const handleDetailPoint = (index: string) => {
    if (!id) return;
    navigate(adminRouteAbsolute.areaScopeMoistualPointsDetail.replace(':id', id).replace(':index', index), {
      state: { area: areaName, checkAddScope },
    });
  };

  const handleOpenCreateMoisturePoints = () => {
    if (!id) return;
    navigate(adminRouteAbsolute.areaScopeMoistualPointsDetail.replace(':id', id).replace(':index', 'create'), {
      state: { area: areaName, checkAddScope },
    });
  };
  //#endregion Handlers

  return (
    <Box>
      <Box className='flex flex-row items-center'>
        <IconButton onClick={handleSetOpen} className='p-0 w-[40px] h-[40px]'>
          <ArrowLeftDoubleIcon className='w-[11px]' />
        </IconButton>
        <Box>{areaName}</Box>
      </Box>

      <DialogContent>
        <List>
          {items.map((mp: any, idx: number) => (
            <ListItem key={mp?.id ?? idx} divider>
              <ListItemText primary={`Moisture Point ${mp?.moisturePoint || 0}`} />
              <ListItemIcon>
                <IconButton className='hover:bg-[unset] ml-[30px]' onClick={() => handleDetailPoint(String(mp?.id))}>
                  <ArrowRightIcon className='w-[13px] h-[13px] stroke-[#797D8A]' />
                </IconButton>
              </ListItemIcon>
            </ListItem>
          ))}
        </List>

        <Box className='flex justify-end w-full'>
          <Button variant='text' startIcon={<PlusIcon />} onClick={handleOpenCreateMoisturePoints}>
            {t('addNewMoisturePoint')}
          </Button>
        </Box>
      </DialogContent>
    </Box>
  );
};

export default AreaScopeListMoisturePoints;
